import { render, staticRenderFns } from "./UniformSysConfigView.vue?vue&type=template&id=2afd55d6&scoped=true&"
import script from "./UniformSysConfigView.vue?vue&type=script&lang=js&"
export * from "./UniformSysConfigView.vue?vue&type=script&lang=js&"
import style0 from "./UniformSysConfigView.vue?vue&type=style&index=0&id=2afd55d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afd55d6",
  null
  
)

export default component.exports